import { StringField } from "../../../types/types";
import { CarouselCardHighlightsFields, CarouselCardHighlightsProps } from '../types/CarouselCardHighlights.types';


export class CarouselCardHighlightsModel {
  private readonly fields?: CarouselCardHighlightsFields;
  constructor(props: CarouselCardHighlightsProps) {
    this.fields = props.fields;
  }

  get title(): StringField | undefined {
    return this.fields?.Title
    // ?? mockTitle;
  }

  
  get eyebrow(): StringField | undefined{
    return this.fields?.Eyebrow 
    //?? mockEyebrow;
  }

 

}

